import styled from "@emotion/styled";

export const ActionPane = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
  justify-content: center;

  margin-top: 12px;
`;
